import clsx from "clsx";
import { useState, type JSX } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";

import { CarouselNavigationButtons } from "@/components/CarouselNavigationButtons";

import "./styles.css";

interface Props {
  slides: (() => JSX.Element)[];
  className?: string;
}

export const HomeMainCarousel = ({ slides, className }: Props): JSX.Element => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div
      className={clsx(
        "home-main-carousel relative mt-[-.7rem] flex w-full justify-center",
        "lg:mt-[-25] absolute",
        className,
      )}
    >
      <div className="relative w-full overflow-visible">
        <Swiper
          onSlideChange={({ realIndex }) => setCurrentIndex(realIndex)}
          className="w-full"
          modules={[Navigation, Autoplay]}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          navigation={{
            disabledClass: "disabled",
            nextEl: "#swiper-button-next",
            prevEl: "#swiper-button-prev",
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>{slide}</SwiperSlide>
          ))}
        </Swiper>

        <CarouselNavigationButtons id="swiper" className="home-main-carousel !text-brand-variation-1" />

        <div className="absolute bottom-4 left-1/2 z-[8] hidden -translate-x-1/2 gap-1 lg:flex">
          {slides.map((_, slideIndex) => (
            <div
              key={slideIndex}
              className={clsx(
                "z-10 h-1 rounded-lg transition-all duration-500 lg:mt-1",
                slideIndex === currentIndex ? "w-4 bg-brand-accent" : "w-1 bg-base-input",
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
